module.exports = __webpack_public_path__ + "static/img/win.c1daad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/info/win.png
// module id = plmH
// module chunks = 1